<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<template>

    <div class="sdev-card">

        <table class="sdev-table sdev-table--hover">

            <thead>
                <tr>

                    <th v-for="field in visibleFields" :key="field.key">
                        {{ field.label }}
                    </th>

                </tr>
            </thead>

            <tbody>

                <tr v-for="row in rows" :key="row[primaryKey]">

                    <td v-for="field in visibleFields" :key="field.key">

                        {{ row[field.key] }}

                    </td>

                </tr>

            </tbody>

        </table>

    </div>

</template>

<script setup>

import { computed } from "vue"

const props = defineProps({
    entity: Object,
    rows: Array
})
const primaryKey = computed(() =>
    props.entity.fields.find(f => f.key.endsWith("_id"))?.key
)
const visibleFields = computed(() =>
    props.entity.fields.filter(f => f.visible !== false)
)

</script>